"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.injectStyle = exports.injectScript = void 0;

var constants_1 = require("./constants");

exports.injectScript = function (_a) {
  var onReady = _a.onReady,
      onError = _a.onError; // tslint:disable:no-expression-statement

  var script = document.createElement('script');
  var header = document.querySelector('head');
  script.setAttribute('type', 'text/javascript');
  script.setAttribute('async', 'true');
  script.setAttribute('defer', 'true');
  script.setAttribute('src', constants_1.FRAMEPAY_SCRIPT_LINK);
  script.setAttribute('defer', 'true');
  script.addEventListener('load', function () {
    return onReady();
  });
  script.addEventListener('error', function () {
    return onError();
  });

  if (header) {
    header.appendChild(script);
  } // tslint:enable:no-expression-statement

};

exports.injectStyle = function () {
  // tslint:disable:no-expression-statement
  var style = document.createElement('link');
  var header = document.querySelector('head');
  style.setAttribute('rel', 'stylesheet');
  style.setAttribute('href', constants_1.FRAMEPAY_STYLE_LINK);

  if (header) {
    header.appendChild(style);
  } // tslint:enable:no-expression-statement

};